var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.268a.59.59 0 0 1-.195.436l-4.317 4.304a.68.68 0 0 1-.211.15.57.57 0 0 1-.225.045.554.554 0 0 1-.566-.56c0-.078.013-.153.039-.224a.5.5 0 0 1 .117-.186L10.1 10.75l2.585-2.357.13.325-2.096.13H2.483a.553.553 0 0 1-.413-.162.57.57 0 0 1-.16-.417.57.57 0 0 1 .16-.416.553.553 0 0 1 .413-.163h8.236l2.096.13-.13.319-2.585-2.35-1.458-1.485a.5.5 0 0 1-.117-.185.652.652 0 0 1-.04-.225.554.554 0 0 1 .566-.56c.157 0 .298.061.424.183l4.33 4.316a.59.59 0 0 1 .195.436z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.6ca29679efcad09606ba60aae61d0b39.svg";
export { ForwardRef as ReactComponent };